import { TypographyColors, TableCellTypes } from '@carboledger/ui';
import {
  CellText,
  makeUnitTypeCell,
  makeUnitScopedCell,
  makeDiscrepanciesCell,
} from '@/components/common';
import { buildShipmentStatusVariants } from '@/config/statuses';
import { SHIPMENT_STATUS_TONE } from '@/config/statusTones';
import { buildRowUnitOptions } from './declarationUnits';

// Linked incoming shipments — the contract tab's columns; only S.No., Terminal and Unit type pin.
// TODO: add the info icons on the headers that carry one once a Tooltip ships.

const LinkedContractCell = ({ value }) => (
  <CellText color={TypographyColors.brand}>{value}</CellText>
);
const renderLinkedContract = (ctx) => <LinkedContractCell value={ctx.value} />;

const renderUnitType = makeUnitTypeCell((t, row) => buildRowUnitOptions(t, row.byUnit));

export const buildDeclarationLinkedShipmentsColumns = (t, { onOpenDiscrepancy }) => [
  {
    id: 'serialNo',
    header: t('FIELD_SERIAL_NO'),
    type: TableCellTypes.text,
    width: 80,
    sortable: true,
    pinnable: true,
  },
  {
    id: 'shipmentId',
    header: t('FIELD_SHIPMENT_ID'),
    type: TableCellTypes.text,
    width: 120,
    sortable: true,
  },
  {
    id: 'linkedContract',
    header: t('CONTRACTS_LINKED_SHIPMENTS_COL_LINKED_CONTRACT'),
    type: TableCellTypes.custom,
    width: 200,
    sortable: true,
    cell: renderLinkedContract,
  },
  {
    id: 'shipmentStatus',
    header: t('CONTRACTS_LINKED_SHIPMENTS_COL_SHIPMENT_STATUS'),
    type: TableCellTypes.statusDot,
    width: 110,
    sortable: true,
    variantMap: buildShipmentStatusVariants(t, SHIPMENT_STATUS_TONE),
  },
  {
    id: 'terminal',
    header: t('FIELD_TERMINAL'),
    type: TableCellTypes.text,
    width: 141,
    sortable: true,
    pinnable: true,
  },
  {
    id: 'unitType',
    header: t('UNIT_TYPE_ARIA'),
    type: TableCellTypes.custom,
    width: 252,
    sortable: true,
    pinnable: true,
    cell: renderUnitType,
  },
  {
    id: 'assignedQty',
    header: t('FIELD_ASSIGNED_QUANTITY_DECLARATION'),
    type: TableCellTypes.custom,
    width: 200,
    sortable: true,
    cell: makeUnitScopedCell('assignedQty'),
  },
  {
    id: 'actualShipmentQty',
    header: t('CONTRACTS_LINKED_SHIPMENTS_COL_ACTUAL_SHIPMENT_QTY'),
    type: TableCellTypes.custom,
    width: 200,
    sortable: true,
    cell: makeUnitScopedCell('actualShipmentQty'),
  },
  {
    id: 'unassignedQty',
    header: t('CONTRACTS_LINKED_SHIPMENTS_COL_UNASSIGNED_QTY'),
    type: TableCellTypes.custom,
    width: 140,
    sortable: true,
    cell: makeUnitScopedCell('unassignedQty'),
  },
  {
    id: 'pendingQty',
    header: t('FIELD_PENDING_QUANTITY'),
    type: TableCellTypes.custom,
    width: 200,
    sortable: true,
    cell: makeUnitScopedCell('pendingQty'),
  },
  {
    id: 'availableQty',
    header: t('FIELD_AVAILABLE_QUANTITY'),
    type: TableCellTypes.custom,
    width: 200,
    sortable: true,
    cell: makeUnitScopedCell('availableQty'),
  },
  {
    id: 'ghgEmissions',
    header: t('FIELD_GHG_EMISSIONS'),
    type: TableCellTypes.text,
    width: 200,
    sortable: true,
  },
  {
    id: 'ghgEmissionSavings',
    header: t('FIELD_GHG_EMISSION_SAVINGS'),
    type: TableCellTypes.text,
    width: 200,
    sortable: true,
  },
  {
    id: 'rawMaterialType',
    header: t('FIELD_RAW_MATERIAL_TYPE'),
    type: TableCellTypes.text,
    width: 200,
    sortable: true,
  },
  {
    id: 'countryOfOrigin',
    header: t('FIELD_COUNTRY_OF_ORIGIN'),
    type: TableCellTypes.text,
    width: 200,
    sortable: true,
  },
  {
    id: 'feedstockCategory',
    header: t('FIELD_FEEDSTOCK_CATEGORY'),
    type: TableCellTypes.text,
    width: 200,
    sortable: true,
  },
  {
    id: 'allocationPreference',
    header: t('FIELD_ALLOCATION_PREFERENCE'),
    type: TableCellTypes.text,
    width: 200,
    sortable: true,
  },
  {
    id: 'dateOfDispatch',
    header: t('FIELD_DATE_OF_DISPATCH'),
    type: TableCellTypes.date,
    width: 150,
    sortable: true,
  },
  {
    id: 'discrepancies',
    header: t('FIELD_DISCREPANCIES'),
    type: TableCellTypes.custom,
    width: 200,
    sortable: true,
    cell: makeDiscrepanciesCell(onOpenDiscrepancy),
  },
];
